// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import Vant from 'vant'
import './styles/libs/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import 'vant/lib/index.less'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import pathUtils from './util/pathUtils'

Vue.config.productionTip = false
/* 兼容旧版 Popconfirm 事件名（新版 confirm -> 旧版 onConfirm） */
/* 需在 Vue.use(ElementUI) 之前添加 */
const Popconfirm = ElementUI.Popconfirm
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.confirm) {
  const originalConfirm = Popconfirm.methods.confirm
  Popconfirm.methods.confirm = function () {
    this.$emit('onConfirm')
    originalConfirm.call(this)
  }
}
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.cancel) {
  const originalCancel = Popconfirm.methods.cancel
  Popconfirm.methods.cancel = function () {
    this.$emit('onCancel')
    originalCancel.call(this)
  }
}
/* 引入cookie工具 */
Vue.use(VueCookies)
/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
/* 引入Vant */
Vue.use(Vant)

/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  return new Promise((resolve, reject) => {
    let requestUrl = config.url
    if (requestUrl && requestUrl.startsWith('/')) {
      config.url = pathUtils.getContextPath(requestUrl)
    }
    store.dispatch('globalRequestHeaders', requestUrl).then(val => {
      if (val) {
        Object.keys(val).forEach(key => {
          config.headers.common[key] = val[key]
        })
      }
      resolve(config)
    }).catch(err => {
      reject(err)
    })
  })
})

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = function (config) {
  config.instance = this
  return $axios(config)
}
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$extend = function () {
  return Object.assign({}, ...arguments)
}
Vue.prototype.$contextPath = pathUtils.getContextPath

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
